import { getNodeApiBaseUrl } from "../../../api/nodeApiBaseUrl.ts";
import { API_BASE_URL } from "../../../services/api";
import { tokenManager } from "../../../utils/tokenManager";
import { userTimezoneHeaders } from "../../../utils/userTimezoneHeader";
import { resolveHotspotContentUrl } from "./patrolAssetHotspotContent";

/** @param {string} url */
export function patrolHotspotPdfNeedsAuthFetch(url) {
  const s = String(url ?? "").trim();
  if (!s || /^blob:|^data:/i.test(s)) return false;
  const bases = [getNodeApiBaseUrl(), API_BASE_URL]
    .map((b) => String(b ?? "").trim().replace(/\/$/, ""))
    .filter(Boolean);
  return bases.some((base) => s === base || s.startsWith(`${base}/`));
}

/**
 * Load a hotspot PDF for in-app preview (Bearer + blob URL when on API host).
 * @param {string} url
 * @returns {Promise<string>} viewer URL (blob or absolute https)
 */
export async function loadPatrolHotspotPdfViewerUrl(url) {
  const resolved = resolveHotspotContentUrl(url) || String(url ?? "").trim();
  if (!resolved) {
    throw new Error("No PDF URL configured.");
  }
  if (!patrolHotspotPdfNeedsAuthFetch(resolved)) {
    return resolved;
  }

  const token = tokenManager.getToken();
  const res = await fetch(resolved, {
    method: "GET",
    headers: {
      Accept: "application/pdf,*/*",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...userTimezoneHeaders(),
    },
    credentials: "include",
  });

  if (!res.ok) {
    throw new Error(`PDF could not be loaded (${res.status}).`);
  }

  const blob = await res.blob();
  const type = String(blob.type || "").toLowerCase();
  if (type.includes("json") || type.includes("html")) {
    throw new Error("PDF file is not available on the server.");
  }
  return URL.createObjectURL(blob);
}
